const privateRoutes = {
  HOME: 'home',
  AGENT: 'agent',
  CONTACTS: 'contacts',
  VOICEMAIL: 'voicemail',
  INTENT: 'intent',
  DASHBOARD_OVERVIEW: 'dashboard/overview',
  DASHBOARD_SESSIONS: 'dashboard',
  DASHBOARD_SESSION: 'dashboard/session/:sessionId',
  DASHBOARD_INTEGRATIONS: 'dashboard/integrations',
  CALENDAR: 'calendar',
  ADMINCONSOLE: 'adminconsole',
  SETTINGS: 'settings/:activeTab',
  OUTREACH: 'settings/app/outreach',
  SALESFORCE: 'settings/app/salesforce',
  HUBSPOT: 'settings/app/hubspot',
  WIZARD: 'sessions/new',
  SESSION_DASHBOARD: 'sessions/:id',
} as const;

export type PrivateRoutes = typeof privateRoutes;
export { privateRoutes };
